import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import TheAbilenePropertyExperts from "./sections/TheAbilenePropertyExperts";
import AbileneMarketPerformance from "./sections/AbileneMarketPerformance";
import ManagementSolutions from "./sections/ManagementSolutions";
import TheTailletStandard from "./sections/TheTailletStandard";
import FeaturedAbileneSpaces from "./sections/FeaturedAbileneSpaces";
import ClientSuccessStories from "./sections/ClientSuccessStories";
import SiteFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <TheAbilenePropertyExperts />
      <AbileneMarketPerformance />
      <ManagementSolutions />
      <TheTailletStandard />
      <FeaturedAbileneSpaces />
      <ClientSuccessStories />
      <SiteFooter />
    </div>;
}